module.exports = __webpack_public_path__ + "static/media/lizzie1.56be785a.jpg";